var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayblack = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.279,
    height: 25.646,
    viewBox: "0 0 26.279 25.646",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_932",
    "data-name": "Ret\\xE2ngulo 932",
    width: 26.279,
    height: 25.646,
    fill: "#35245d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2080",
    "data-name": "Grupo 2080",
    transform: "translate(0 1.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1931",
    "data-name": "Grupo 1931",
    transform: "translate(0 -1.402)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5235",
    "data-name": "Caminho 5235",
    d: "M25.906,11.521a2.868,2.868,0,0,0-1.151-1.008L20.746,8.5,9.834,3,4.589.361A3.3,3.3,0,0,0,3.007,0,3.327,3.327,0,0,0,1.529.364a2.838,2.838,0,0,0-1.1.937A2.376,2.376,0,0,0,0,2.67V22.977a2.369,2.369,0,0,0,.428,1.368,2.821,2.821,0,0,0,1.1.932,3.334,3.334,0,0,0,1.478.369,3.4,3.4,0,0,0,1.582-.366L24.755,15.127a2.861,2.861,0,0,0,1.151-1,2.452,2.452,0,0,0,0-2.6",
    transform: "translate(0 0)",
    fill: "#35245d"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayblack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/playblack.175b8353b3373d02.svg";